export const formatNumberAsCurrency = (num: number) =>
  `${Math.sign(num) === -1 ? '-' : ''}$${Math.abs(num)
    .toFixed(0)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`;
